// import { Close, FilterList } from '@mui/icons-material'
// import { Box, Button, Checkbox, Drawer, FormControlLabel, Grid, IconButton, Radio, Slider, Typography } from '@mui/material'
// import React, { useEffect, useRef, useState } from 'react'
// import { Product } from '../../types/Products'
// import { Shimmer } from '../../Component/Skeletones/Skeletones'
// import ProductCard from '../../Component/ProductCard/ProductCard'
// import { toast } from 'react-toastify'
// import { ApiGetCategories, ApiGetProducts } from '../../Core/Apicall'
// import { Category } from '../../types/Category'


// const discountRanges = [
//     {
//         name: "10% and above",
//         value: "10"
//     },
//     {
//         name: "20% and above",
//         value: "20"
//     },
//     {
//         name: "30% and above",
//         value: "30"
//     },
//     {
//         name: "40% and above",
//         value: "40"
//     },
//     {
//         name: "50% and above",
//         value: "50"
//     },
//     {
//         name: "60% and above",
//         value: "60"
//     },
// ]
// const FilterContent = ({
//     categoryList,
//     price,
//     onPriceChange,
//     selectedDiscount,
//     setSelectedDiscount,
//     selectedCategory,
//     setSelectedCategory

// }: {
//     categoryList: Category[]
//     price: number[];
//     onPriceChange: (_: Event, val: number | number[]) => void;
//     selectedDiscount: any;
//     setSelectedDiscount: (val: any) => void;
//     selectedCategory: any;
//     setSelectedCategory: (categoryId: number | null) => void;

// }) => {
//     console.log("Price", price)
//     return (
//         <Box className='border-main  border-10 mx-2'>
//             {/* Categories */}
//             <Box className='filters p-4'>
//                 <Typography className='fs-16 fw-medium mb-2'>CATEGORIES</Typography>
//                 <FormControlLabel
//                     control={
//                         <Radio
//                             className="p-2"
//                             size="small"
//                             checked={selectedCategory === null}
//                             onChange={() => setSelectedCategory(null)}
//                         />
//                     }
//                     label={
//                         <Box className="d-flex align-items-center gap-1">
//                             <Typography className="fs-14">All</Typography>
//                         </Box>
//                     }
//                     sx={{
//                         display: 'flex',
//                         alignItems: 'center',
//                         margin: 0,
//                         width: '100%',
//                         '& .MuiFormControlLabel-label': {
//                             flex: 1
//                         }
//                     }}
//                 />
//                 {categoryList.map((category: Category) => (
//                     <FormControlLabel
//                         key={category?.categoryId}
//                         control={
//                             <Radio
//                                 className="p-2"
//                                 size="small"
//                                 checked={selectedCategory === category?.categoryId}
//                                 onChange={() => setSelectedCategory(category?.categoryId)}
//                             />
//                         }
//                         label={
//                             <Box className='d-flex align-items-center gap-1'>
//                                 <Typography className='fs-14'>{category.categoryName}</Typography>
//                             </Box>
//                         }
//                         sx={{ display: 'flex', alignItems: 'center', margin: 0, width: '100%', '& .MuiFormControlLabel-label': { flex: 1 } }}
//                     />
//                 ))}
//             </Box>

//             <hr className='w-100 border-white m-0' />
//             {/* Price */}
//             <Box className='filters p-4'>
//                 <Typography className='fs-16  fw-medium mb-2'>PRICE</Typography>
//                 <Slider className='slider' value={price} onChange={onPriceChange} min={10} max={price[1]} valueLabelDisplay='off' />
//                 <Box className='d-flex align-items-center justify-content-between'>
//                     <Typography className='fs-14  fw-bold'>
//                         {Number(price[0]).toLocaleString("en-US", {
//                             style: "currency",
//                             currency: "INR",
//                         })}
//                         {/* $ {price[0].toLocaleString()} */}
//                     </Typography>
//                     <Typography className='fs-14  fw-bold'>
//                         {Number(price[1]).toLocaleString("en-US", {
//                             style: "currency",
//                             currency: "INR",
//                         })}
//                     </Typography>
//                 </Box>
//             </Box>

//             <hr className='w-100 border-white m-0' />

//             {/* Discount */}
//             <Box className='filters p-4'>
//                 <Typography className='fs-16  fw-medium mb-2'>DISCOUNT</Typography>
//                 {discountRanges.map((discount, index) => (
//                     <FormControlLabel
//                         key={index}
//                         control={
//                             <Radio
//                                 className='radio p-2'
//                                 size='small'
//                                 checked={selectedDiscount === discount.value}
//                                 onChange={(e) => setSelectedDiscount(discount.value)}
//                             />
//                         }
//                         label={<Typography className='fs-14 '>{discount?.name}</Typography>}
//                         sx={{ display: 'flex', alignItems: 'center', margin: 0, width: '100%' }}
//                     />
//                 ))}
//             </Box>
//         </Box>
//     )
// }

// function DealerProducts() {
//     const [filterDrawerOpen, setFilterDrawerOpen] = useState(false)
//     const [price, setPrice] = useState<number[]>([])
//     const [debouncedPrice, setDebouncedPrice] = useState<any>();
//     const [maxPrice, setMaxPrice] = useState(0);
//     const [selectedDiscount, setSelectedDiscount] = useState(null)
//     const [selectedCategory, setSelectedCategory] = useState<number | null>(null)
//     const [products, setProducts] = useState<Product[]>([]);
//     const [offset, setOffset] = useState(0);
//     const [loading, setLoading] = useState(false);
//     const [hasMore, setHasMore] = useState(true);
//     const [searchTerm, setSearchTerm] = useState<string>("")
//     const loadingRef = useRef(false);
//     const observerRef = useRef<HTMLDivElement>(null);
//     const [categoryList, setCategoryList] = useState<Category[]>([])
//     const [isPriceFilterChanged, setIsPriceFilterChanged] = useState(false);


//     const handlePriceChange = (_: Event, newValue: number | number[]) => {
//         setPrice(newValue as number[])
//         setIsPriceFilterChanged(true);
//     }

//     useEffect(() => {
//         setPrice([10, maxPrice]);
//     }, [maxPrice]);
//     const filterProps = {
//         categoryList,
//         price,
//         onPriceChange: handlePriceChange,
//         selectedDiscount,
//         setSelectedDiscount,
//         selectedCategory,
//         setSelectedCategory,
//     }

//     useEffect(() => {
//         const timer = setTimeout(() => {
//             setDebouncedPrice(price);
//         }, 500);

//         return () => clearTimeout(timer);
//     }, [price]);

//     const LIMIT = 20;

//     const loadProducts = async (
//         currentOffset = 0,
//         reset = false
//     ) => {
//         try {
//             setLoading(true);
//             const res = await ApiGetProducts(`?limit=${LIMIT}&offset=${currentOffset}${selectedDiscount ? `&discount=${selectedDiscount}` : ""}${searchTerm ? `&searchTerm=${searchTerm?.trim()}` : ""}${(debouncedPrice?.length > 0 && isPriceFilterChanged) ? `&minPrice=${debouncedPrice[0]}&maxPrice=${debouncedPrice[1]}` : ""}${selectedCategory ? `&categoryId=${selectedCategory}` : ""}`)
//             if (res?.status) {
//                 const newProducts = res.data || [];

//                 setProducts((prev) =>
//                     reset ? newProducts : [...prev, ...newProducts]
//                 );
//                 const highestPrice = Math.max(
//                     0,
//                     ...res.data.map((product: Product) => Number(product?.discounted_price) || 0)
//                 );
//                 console.log("Highest Price", highestPrice)

//                 setMaxPrice((prev) => Math.max(prev, highestPrice));

//                 setHasMore(newProducts.length == LIMIT || newProducts.length == res?.total);
//             }
//         } catch (error: any) {
//             toast.error(error?.message || "Something went wrong");
//         } finally {
//             setLoading(false);
//         }
//     };

//     useEffect(() => {
//         window.scrollTo({
//             top: 0,
//             behavior: "smooth",
//         });

//         setProducts([]);
//         setOffset(0);
//         setHasMore(true);

//         loadProducts(0, true);
//     }, [searchTerm, selectedDiscount, debouncedPrice, selectedCategory]);


//     const handleLoadMore = () => {
//         if (loadingRef.current || !hasMore) return;
//         // console.log("Has MOre", hasMore)
//         const nextOffset = offset + LIMIT;
//         setOffset(nextOffset);
//         // loadProducts(nextOffset);
//     };

//     useEffect(() => {
//         const observer = new IntersectionObserver(
//             (entries) => {
//                 if (entries[0].isIntersecting) {
//                     handleLoadMore();
//                 }
//             },
//             {
//                 threshold: 0.5,
//             }
//         );

//         if (observerRef.current) {
//             observer.observe(observerRef.current);
//         }

//         return () => observer.disconnect();
//     }, [hasMore, offset]);


//     useEffect(() => {
//         loadingRef.current = loading;
//     }, [loading]);


//     const getCategoryList = async () => {
//         try {
//             const res = await ApiGetCategories()
//             if (res?.status) {
//                 setCategoryList(res?.data)
//             }
//         } catch (error: any) {
//             toast.error(error?.message || "Something went wrong")
//         }
//     }

//     useEffect(() => {
//         getCategoryList()
//     }, [])

//     return (
//         <Box className='p-lg-3 p-xl-4 p-2'>
//             {/* ── Mobile filter bar ── */}
//             <Box
//                 className='d-flex d-md-none align-items-center justify-content-between mb-3'
//             >
//                 <Typography className='fs-14'>Shoes - 4527 items</Typography>
//                 <Button
//                     startIcon={<FilterList />}
//                     variant='outlined'
//                     size='small'
//                     className='btn-outlined'
//                     onClick={() => setFilterDrawerOpen(true)}
//                 >
//                     Filters
//                 </Button>
//             </Box>

//             {/* ── Mobile Filter Drawer ── */}
//             <Drawer
//                 anchor='left'
//                 open={filterDrawerOpen}
//                 onClose={() => setFilterDrawerOpen(false)}
//                 slotProps={{
//                     paper: { sx: { width: 300, overflowX: 'hidden' } }
//                 }}
//             >
//                 {/* Drawer header */}
//                 <Box className='d-flex align-items-center justify-content-between p-3'>
//                     <Typography className=' fw-bold fs-18'>FILTERS</Typography>
//                     <IconButton onClick={() => setFilterDrawerOpen(false)} sx={{ color: 'white' }}>
//                         <Close className='text-dark' />
//                     </IconButton>
//                 </Box>

//                 <FilterContent {...filterProps} />

//                 {/* Apply button */}
//                 <Box className='p-3'>
//                     <Button variant='contained' fullWidth className='btn-main' onClick={() => setFilterDrawerOpen(false)}>
//                         Apply Filters
//                     </Button>
//                 </Box>
//             </Drawer>

//             <Grid container>

//                 {/* ── Desktop Sidebar Filters ── */}
//                 <Grid size={{ xs: 0, sm: 3.5, lg: 3, xl: 2.5 }} sx={{ display: { xs: 'none', sm: 'block' } }}>
//                     <Typography className=' fw-bold fs-18 mb-4'>FILTERS</Typography>
//                     <Box className='px-2'>
//                         <FilterContent {...filterProps} />
//                     </Box>
//                 </Grid>

//                 {/* ── Product Grid ── */}
//                 <Grid size={{ xs: 12, sm: 8.5, lg: 9, xl: 9.5 }} className='overflow-hidden'>
//                     <Grid container spacing={{ xs: 2, md: 2 }} className='w-100' sx={{ flexWrap: 'wrap' }}>
//                         {products?.length ? (
//                             products.map((product: Product, i: number) => (
//                                 <Grid key={i} size={{ xs: 6, sm: 4, xl: 'auto' }}>
//                                     <ProductCard product={product} />
//                                 </Grid>
//                             ))
//                         ) : (
//                             loading ? Array.from({ length: 20 }).map((_, index) => (
//                                 <Grid key={index} size={{ xs: 6, sm: 4, xl: 3 }}>
//                                     <Shimmer
//                                         height={{
//                                             xs: "250px",
//                                             md: "250px",
//                                             lg: "300px",
//                                         }}
//                                         width="100%"
//                                         borderRadius={5}
//                                     />
//                                 </Grid>
//                             ))
//                                 : (
//                                     <Box className='mt-5 mx-auto'>
//                                         <Typography className=' fs-20 m-auto mt-5'>No Products Found</Typography>
//                                     </Box>
//                                 )
//                         )}

//                         {loading && products?.length > 0 &&
//                             Array.from({ length: 8 }).map((_, index) => (
//                                 <Grid key={`load-more-${index}`} size={{ xs: 6, sm: 4, xl: 3 }}>
//                                     <Shimmer
//                                         height={{
//                                             xs: "250px",
//                                             md: "250px",
//                                             lg: "300px",
//                                         }}
//                                         width="100%"
//                                         borderRadius={5}
//                                     />
//                                 </Grid>
//                             ))}

//                         <Grid size={12}>
//                             <div ref={observerRef} style={{ height: 20 }} />
//                         </Grid>
//                     </Grid>
//                 </Grid>

//             </Grid>
//         </Box>
//     )
// }

// export default DealerProducts

import { Close, FilterList } from '@mui/icons-material'
import { Box, Button, Checkbox, Drawer, FormControlLabel, Grid, IconButton, Radio, Slider, Typography } from '@mui/material'
import React, { useCallback, useEffect, useRef, useState } from 'react'
import { Product } from '../../types/Products'
import { Shimmer } from '../../Component/Skeletones/Skeletones'
import ProductCard from '../../Component/ProductCard/ProductCard'
import { toast } from 'react-toastify'
import { ApiGetCategories, ApiGetProducts } from '../../Core/Apicall'
import { Category } from '../../types/Category'


const discountRanges = [
    {
        name: "10% and above",
        value: "10"
    },
    {
        name: "20% and above",
        value: "20"
    },
    {
        name: "30% and above",
        value: "30"
    },
    {
        name: "40% and above",
        value: "40"
    },
    {
        name: "50% and above",
        value: "50"
    },
    {
        name: "60% and above",
        value: "60"
    },
]
const MIN_PRICE = 0
const LIMIT = 20

const FilterContent = ({
    categoryList,
    price,
    minPrice,
    maxPrice,
    onPriceChange,
    onPriceCommit,
    selectedDiscount,
    setSelectedDiscount,
    selectedCategory,
    setSelectedCategory
}: {
    categoryList: Category[]
    price: number[];
    minPrice: number;
    maxPrice: number;
    onPriceChange: (_: Event, val: number | number[]) => void;
    onPriceCommit: (_: Event | React.SyntheticEvent, val: number | number[]) => void;
    selectedDiscount: string | null;
    setSelectedDiscount: (val: string | null) => void;
    selectedCategory: number | null;
    setSelectedCategory: (categoryId: number | null) => void;
}) => {
    return (
        <Box className='border-main  border-10 mx-2'>
            {/* Categories */}
            <Box className='filters p-4'>
                <Typography className='fs-16 fw-medium mb-2'>CATEGORIES</Typography>
                <FormControlLabel
                    control={
                        <Radio
                            className="p-2"
                            size="small"
                            checked={selectedCategory === null}
                            onChange={() => setSelectedCategory(null)}
                        />
                    }
                    label={
                        <Box className="d-flex align-items-center gap-1">
                            <Typography className="fs-14">All</Typography>
                        </Box>
                    }
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        margin: 0,
                        width: '100%',
                        '& .MuiFormControlLabel-label': {
                            flex: 1
                        }
                    }}
                />
                {categoryList.map((category: Category) => (
                    <FormControlLabel
                        key={category?.categoryId}
                        control={
                            <Radio
                                className="p-2"
                                size="small"
                                checked={selectedCategory === category?.categoryId}
                                onChange={() => setSelectedCategory(category?.categoryId)}
                            />
                        }
                        label={
                            <Box className='d-flex align-items-center gap-1'>
                                <Typography className='fs-14'>{category.categoryName}</Typography>
                            </Box>
                        }
                        sx={{ display: 'flex', alignItems: 'center', margin: 0, width: '100%', '& .MuiFormControlLabel-label': { flex: 1 } }}
                    />
                ))}
            </Box>

            <hr className='w-100 border-white m-0' />
            {/* Price */}
            <Box className='filters p-4'>
                <Typography className='fs-16  fw-medium mb-2'>PRICE</Typography>
                <Slider className='slider' value={price} onChange={onPriceChange} onChangeCommitted={onPriceCommit} min={minPrice} max={Math.max(maxPrice, minPrice + 1)} disabled={maxPrice <= minPrice} disableSwap valueLabelDisplay='off' />
                <Box className='d-flex align-items-center justify-content-between'>
                    <Typography className='fs-14  fw-bold'>
                        {Number(price[0]).toLocaleString("en-US", {
                            style: "currency",
                            currency: "INR",
                        })}
                        {/* $ {price[0].toLocaleString()} */}
                    </Typography>
                    <Typography className='fs-14  fw-bold'>
                        {Number(price[1]).toLocaleString("en-US", {
                            style: "currency",
                            currency: "INR",
                        })}
                    </Typography>
                </Box>
            </Box>

            <hr className='w-100 border-white m-0' />

            {/* Discount */}
            <Box className='filters p-4'>
                <Typography className='fs-16  fw-medium mb-2'>DISCOUNT</Typography>
                {discountRanges.map((discount, index) => (
                    <FormControlLabel
                        key={index}
                        control={
                            <Radio
                                className='radio p-2'
                                size='small'
                                checked={selectedDiscount === discount.value}
                                onChange={(e) => setSelectedDiscount(discount.value)}
                            />
                        }
                        label={<Typography className='fs-14 '>{discount?.name}</Typography>}
                        sx={{ display: 'flex', alignItems: 'center', margin: 0, width: '100%' }}
                    />
                ))}
            </Box>
        </Box>
    )
}

function DealerProducts() {
    const [filterDrawerOpen, setFilterDrawerOpen] = useState(false)
    // price = live slider value (updates while dragging); appliedPrice = value sent to the API (set on release)
    const [price, setPrice] = useState<number[]>([MIN_PRICE, 0])
    const [appliedPrice, setAppliedPrice] = useState<number[] | null>(null)
    const [maxPrice, setMaxPrice] = useState(0);
    const [selectedDiscount, setSelectedDiscount] = useState<string | null>(null)
    const [selectedCategory, setSelectedCategory] = useState<number | null>(null)
    const [products, setProducts] = useState<Product[]>([]);
    const [loading, setLoading] = useState(false);
    const [hasMore, setHasMore] = useState(true);
    const [searchTerm, setSearchTerm] = useState<string>("")
    const [categoryList, setCategoryList] = useState<Category[]>([])
    const loadingRef = useRef(false);
    const requestIdRef = useRef(0);
    const priceTouchedRef = useRef(false);
    const observerRef = useRef<HTMLDivElement>(null);

    const handlePriceChange = (_: Event, newValue: number | number[]) => {
        priceTouchedRef.current = true;
        setPrice(newValue as number[])
    }

    // Fires once when the user releases the thumb -> one API call, no debounce needed
    const handlePriceCommit = (_: Event | React.SyntheticEvent, newValue: number | number[]) => {
        const [min, max] = newValue as number[];
        if (min <= MIN_PRICE && max >= maxPrice) {
            priceTouchedRef.current = false;
            setAppliedPrice(null);          // full range = no price filter
        } else {
            setAppliedPrice([min, max]);
        }
    }

    // Until the user touches the slider, keep it at the full range as maxPrice is discovered.
    // Never overwrite a range the user has chosen.
    useEffect(() => {
        if (!priceTouchedRef.current) {
            setPrice([MIN_PRICE, maxPrice]);
        }
    }, [maxPrice]);

    const filterProps = {
        categoryList,
        price,
        minPrice: MIN_PRICE,
        maxPrice,
        onPriceChange: handlePriceChange,
        onPriceCommit: handlePriceCommit,
        selectedDiscount,
        setSelectedDiscount,
        selectedCategory,
        setSelectedCategory,
    }

    const loadProducts = useCallback(async (currentOffset: number, reset: boolean) => {
        const requestId = ++requestIdRef.current;   // newest request wins; older responses are ignored
        loadingRef.current = true;
        setLoading(true);
        try {
            const params = new URLSearchParams({ limit: String(LIMIT), offset: String(currentOffset) });
            if (selectedDiscount) params.set('discount', selectedDiscount);
            if (searchTerm.trim()) params.set('searchTerm', searchTerm.trim());
            if (appliedPrice) {
                params.set('minPrice', String(appliedPrice[0]));
                params.set('maxPrice', String(appliedPrice[1]));
            }
            if (selectedCategory) params.set('categoryId', String(selectedCategory));

            const res = await ApiGetProducts(`?${params.toString()}`)
            if (requestId !== requestIdRef.current) return;

            if (res?.status) {
                const newProducts: Product[] = res.data || [];
                setProducts((prev) => (reset ? newProducts : [...prev, ...newProducts]));

                const highestPrice = Math.max(0, ...newProducts.map((p) => Number(p?.discounted_price) || 0));
                setMaxPrice((prev) => Math.max(prev, Math.ceil(highestPrice)));

                setHasMore(newProducts.length === LIMIT);
            } else {
                setHasMore(false);
            }
        } catch (error: any) {
            if (requestId === requestIdRef.current) {
                setHasMore(false);   // stop the observer retrying a failing request forever
                toast.error(error?.message || "Something went wrong");
            }
        } finally {
            if (requestId === requestIdRef.current) {
                loadingRef.current = false;
                setLoading(false);
            }
        }
    }, [selectedDiscount, searchTerm, appliedPrice, selectedCategory]);

    // loadProducts changes identity only when a filter changes -> reload from the start
    useEffect(() => {
        window.scrollTo({ top: 0, behavior: "smooth" });
        setProducts([]);
        setHasMore(true);
        loadProducts(0, true);
    }, [loadProducts]);

    // Infinite scroll: offset is simply how many products we already have
    useEffect(() => {
        const node = observerRef.current;
        if (!node || !hasMore || loading) return;

        const observer = new IntersectionObserver(
            (entries) => {
                if (entries[0].isIntersecting && !loadingRef.current) {
                    loadProducts(products.length, false);
                }
            },
            { threshold: 0.5 }
        );
        observer.observe(node);
        return () => observer.disconnect();
    }, [hasMore, loading, products.length, loadProducts]);

    const getCategoryList = async () => {
        try {
            const res = await ApiGetCategories()
            if (res?.status) {
                setCategoryList(res?.data)
            }
        } catch (error: any) {
            toast.error(error?.message || "Something went wrong")
        }
    }

    useEffect(() => {
        getCategoryList()
    }, [])

    return (
        <Box className='p-lg-3 p-xl-4 p-2'>
            {/* ── Mobile filter bar ── */}
            <Box
                className='d-flex d-md-none align-items-center justify-content-between mb-3'
            >
                <Typography className='fs-14'>Shoes - 4527 items</Typography>
                <Button
                    startIcon={<FilterList />}
                    variant='outlined'
                    size='small'
                    className='btn-outlined'
                    onClick={() => setFilterDrawerOpen(true)}
                >
                    Filters
                </Button>
            </Box>

            {/* ── Mobile Filter Drawer ── */}
            <Drawer
                anchor='left'
                open={filterDrawerOpen}
                onClose={() => setFilterDrawerOpen(false)}
                slotProps={{
                    paper: { sx: { width: 300, overflowX: 'hidden' } }
                }}
            >
                {/* Drawer header */}
                <Box className='d-flex align-items-center justify-content-between p-3'>
                    <Typography className=' fw-bold fs-18'>FILTERS</Typography>
                    <IconButton onClick={() => setFilterDrawerOpen(false)} sx={{ color: 'white' }}>
                        <Close className='text-dark' />
                    </IconButton>
                </Box>

                <FilterContent {...filterProps} />

                {/* Apply button */}
                <Box className='p-3'>
                    <Button variant='contained' fullWidth className='btn-main' onClick={() => setFilterDrawerOpen(false)}>
                        Apply Filters
                    </Button>
                </Box>
            </Drawer>

            <Grid container>

                {/* ── Desktop Sidebar Filters ── */}
                <Grid size={{ xs: 0, sm: 3.5, lg: 3, xl: 2.5 }} sx={{ display: { xs: 'none', sm: 'block' } }}>
                    <Typography className=' fw-bold fs-18 mb-4'>FILTERS</Typography>
                    <Box className='px-2'>
                        <FilterContent {...filterProps} />
                    </Box>
                </Grid>

                {/* ── Product Grid ── */}
                <Grid size={{ xs: 12, sm: 8.5, lg: 9, xl: 9.5 }} className='overflow-hidden'>
                    <Grid container spacing={{ xs: 2, md: 2 }} className='w-100' sx={{ flexWrap: 'wrap' }}>
                        {products?.length ? (
                            products.map((product: Product, i: number) => (
                                <Grid key={i} size={{ xs: 6, sm: 4, xl: 'auto' }}>
                                    <ProductCard product={product} />
                                </Grid>
                            ))
                        ) : (
                            loading ? Array.from({ length: 20 }).map((_, index) => (
                                <Grid key={index} size={{ xs: 6, sm: 4, xl: 3 }}>
                                    <Shimmer
                                        height={{
                                            xs: "250px",
                                            md: "250px",
                                            lg: "300px",
                                        }}
                                        width="100%"
                                        borderRadius={5}
                                    />
                                </Grid>
                            ))
                                : (
                                    <Box className='mt-5 mx-auto'>
                                        <Typography className=' fs-20 m-auto mt-5'>No Products Found</Typography>
                                    </Box>
                                )
                        )}

                        {loading && products?.length > 0 &&
                            Array.from({ length: 8 }).map((_, index) => (
                                <Grid key={`load-more-${index}`} size={{ xs: 6, sm: 4, xl: 3 }}>
                                    <Shimmer
                                        height={{
                                            xs: "250px",
                                            md: "250px",
                                            lg: "300px",
                                        }}
                                        width="100%"
                                        borderRadius={5}
                                    />
                                </Grid>
                            ))}

                        <Grid size={12}>
                            <div ref={observerRef} style={{ height: 20 }} />
                        </Grid>
                    </Grid>
                </Grid>

            </Grid>
        </Box>
    )
}

export default DealerProducts
